import React from 'react';
import { useSelector } from 'react-redux';
import { Alert, Button } from 'antd';
import moment from 'moment';
import { downloadBlobFile, writeXlsxFile } from '../../../lib/file';
import { selectors } from '../../../model';
import { uploadingFieldNames } from '../../../config/uploadingStep';

const { selectUploadingStepValue } = selectors;

const createFileName = (label) => {
  const dateTime = moment().utc().format('DD_MM_YYYY HH_mm');

  const firstPart = `Записи с ошибками ${dateTime}`;
  const secondPart = label && `(${label})`;

  return [firstPart, secondPart].filter(Boolean).join(' ');
};

const houseSelector = (state) =>
  selectUploadingStepValue(state, uploadingFieldNames.house);

const Description = ({ file, workbook, children }) => {
  const house = useSelector(houseSelector);

  const handleClick = () => {
    if (file) {
      downloadBlobFile(file);
      return;
    }

    const fileName = createFileName(house?.label);
    writeXlsxFile(workbook, `${fileName}.xlsx`);
  };

  return (
    <div>
      <div>{children}</div>
      <Button onClick={handleClick}>Скачать файл с ошибками</Button>
    </div>
  );
};

const DownloadErrorsFile = ({ file, workbook, children }) => {
  return (
    <Alert
      message="Внимание!"
      description={
        <Description
          file={file}
          workbook={workbook}
        >
          {children}
        </Description>
      }
      type="warning"
      showIcon
    />
  );
};

export default DownloadErrorsFile;
